import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { TransactionCategory } from '@/store/expenses-store/transactions/transactions.dto.ts';

export const useCategoryFilterParam = (
  categories: TransactionCategory[],
  onApply: (categoryTitle: string) => void,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');

  useEffect(() => {
    if (!categoryParam || categories.length === 0) return;
    const matched = categories.find(
      (category) => category.slug === categoryParam || category.title === categoryParam,
    );
    onApply(matched?.title ?? categoryParam);
    const next = new URLSearchParams(searchParams);
    next.delete('category');
    setSearchParams(next, { replace: true });
  }, [categoryParam, categories, onApply, searchParams, setSearchParams]);
};
